/* eslint-disable no-template-curly-in-string */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import comingsoon from "@/assets/comingSoon.png";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Grid,
  Link,
  Pagination,
  Paper,
  Slider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { TopHeadingLayout } from "@/components/layout/TopHeadingLayout";
import HomeScreenImg from "@/assets/earth.jpg";
import quickDrawsImg from "@/assets/quickDrawsImg.png";
import { useAuth } from "@/lib/auth";
import { useLotteries } from "../api/getLottery";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import Countdown from "react-countdown";
import { theme } from "@/components/Elements/theme";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  paperClass: {
    padding: theme.spacing(2),
    textAlign: "center",
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
  },
}));

const dataValue = {
  heading: "Live Lottery Spin",
  subHeading:
    "Buy lottery tickets online for the top international lotteries. Safely and securely playfor the biggest jackpots in the entire world from the comfort of home.",
};

export default function LiveLotteries() {
  const [currentPage, setCurrentPage] = useState<number>(1);
  console.log(currentPage, "currentPage");
  const [totalPages, setTotalPages] = useState<number>(1);
  const limit = 10;
  const classes = useStyles();
  const { user } = useAuth();
  const LotteryQuery: any = useLotteries({ page: currentPage, limit });
  console.log(LotteryQuery?.data?.length , "LotteryQuery")
  useEffect(() => {
    if (LotteryQuery?.data && LotteryQuery?.data?.totalPages) {
      setTotalPages(LotteryQuery?.data.totalPages);
    }
  }, [LotteryQuery?.data]);



if (LotteryQuery?.isLoading || (Array.isArray(LotteryQuery?.data) && LotteryQuery.data.length === 0)) {
    return (
      <Box
        className="w-full h-48 flex justify-center items-center"
        sx={{
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          border: "1px solid",
          marginTop: "90px",
          minHeight: "calc(100vh - 330px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "@media screen and (max-width:992px)": {
            marginTop: "66px",
          },
        }}
      >
        {/* <img src={comingsoon} alt="comingsoon" style={{ width: "100%" }} /> */}
        <img
          src="/Comp_1.gif"
          alt="comingsoon"
          style={{ alignItems: "center" }}
        />
      </Box>
    );
  }

  var content = {
    color: "#ffff",
    backgroundColor: "#050518",
    borderRadius: "12px",
    height: "100%",
    margin: "0px",
  };
  var center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const gridItem = {};
  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setCurrentPage(newPage);
  };
  return (
    <Box
      sx={{
        background: `linear-gradient(89.41deg, #1B1C2D 7.81%, rgba(27, 28, 45, 0) 38.09%), linear-gradient(1.53deg, #1B1C2D 13.32%, rgba(27, 28, 45, 0) 50.41%), linear-gradient(46.49deg, #1B1C2D 14.7%, rgba(27, 28, 45, 0) 43.39%), url(${HomeScreenImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        minHeight: "100%",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        padding: {
          xs: "10px 0",
          lg: "100px 0px 20px",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "95%",
          margin: "0 auto",
          [theme.breakpoints.down("md")]: {},
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "768px",
            margin: "0 auto",
            textAlign: "center",
            fontFamily: '"Ubuntu", sans-serif',
            fontSize: "25px",
            lineHeight: "1.5",
          }}
        >
          <Typography
            component="h4"
            sx={{
              textTransform: "capitalize",
              fontWeight: "500 !important",
              marginBottom: { xs: "10px", md: "15px" },
              fontSize: { xs: "18px", md: "26px" },
            }}
          >
            live Lottery
          </Typography>
        </Box>
        <Box
          sx={{
            padding: { lg: "40px ", xs: "20px 10px 30px" },
            backgroundColor: "rgba(57, 57, 57, 0.8)",
            borderRadius: "10px",
          }}
        >
        
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              justifyContent={{ xs: "start", md: "center" }}
            >
              {LotteryQuery?.data &&
                LotteryQuery?.data?.length > 0 &&
                LotteryQuery?.data?.map((value, index) => (
                  <Grid item key={index} xs={6} sm={4} md={4}>
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: {
                          xs: "column",
                          sm: "column",
                          md: "row",
                        },
                        maxWidth: "780px",
                        cursor: "pointer",
                        position: "relative",
                        borderRadius: "16px !important",
                        overflow: "hidden",
                        "&:hover": {
                          backgroundColor: "#fff !important",
                          color: "black !important",
                          boxShadow: 20,

                          "& div div .MuiDivider-root": {
                            borderBottomColor: "black !important", // Change the color of the Divider component
                          },
                          "& div div div p": {
                            backgroundColor: "#fff !important",
                            color: "black !important",
                          },
                          "& div div .MuiCardContent-root": {
                            backgroundColor: "#fff !important",
                            color: "black !important",
                          },
                          "& div div div div.MuiPaper-root": {
                            border: "1.23px solid #00000038 !important",
                            background: "#fff",
                            boxShadow: "none",
                          },
                          "& div div div div.MuiPaper-root .MuiCardContent-root":
                            {
                              border: "1.23px solid #00000038 !important",
                            },
                        },
                      }}
                      style={content}
                      onClick={() => {
                        window.location.assign(
                          "/app/liveLotteries/" + value._id
                        );
                      }}
                    >
                      {/* <Chip
                          label={`${value?.numOfTicketSold || 0}  Sold`}
                          sx={{
                            position: "absolute",
                            transform: "rotate(45deg)",
                            top: "2px",
                            right: "-31px",
                            backgroundColor: "#fff",
                            color: "Red",
                            borderRadius: "4px",
                            padding: "4px 17px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            zIndex: 1,
                          }}
                        /> */}

                      <Chip
                        label={`${
                          value?.totalTicketsBoughtByUser || 0
                        } Tickets`}
                        sx={{
                          position: "absolute",
                          transform: "rotate(45deg)",
                          top: "10px",
                          right: "-40px",
                          backgroundColor: "blue",
                          color: "#FFFFFF",
                          borderRadius: "4px",
                          padding: "8px 26px",
                          fontSize: "10px",
                          fontWeight: "bold",
                          zIndex: 99,
                          whiteSpace: "nowrap",
                        }}
                      />

                      {value?.numOfTicketOnSale <= 1000 ? (
                        <Chip
                          label={`${value?.numOfTicketOnSale || 0} Tickets`}
                          sx={{
                            position: "absolute",
                            transform: "rotate(-45deg)",
                            top: "10px",
                            left: "-39px",
                            backgroundColor: "#fff",
                            color: "Red",
                            borderRadius: "4px",
                            padding: "8px 26px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            zIndex: 9,
                            whiteSpace: "nowrap",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <CardMedia
                        component="img"
                        image={
                          value.image
                            ? `${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${value.image}`
                            : quickDrawsImg
                        }
                        alt="Live from space album cover"
                        sx={{
                          minWidth: { xs: "100%", md: "45%" },
                          width: { xs: "100%", md: "45%" },
                          minHeight: "250px !important",
                          maxHeight: { xs: "240px", md: "100%" },
                          height: {
                            xs: "200px !important",
                            md: "100% !important",
                          },
                          zIndex: "2",
                          backgroundPosition: "initial",
                          objectFit: "fill !important",
                          borderRadius: "10px",
                          flex: { md: "1 0 45%", xs: "1 0 100%" },
                        }}
                      />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          width: { xs: "100%", md: "65%" },
                        }}
                      >
                        <CardContent
                          style={center}
                          sx={{
                            height: {
                              xs: "100% !important",
                              md: "100% !important",
                            },
                            paddingTop: "30px",
                          }}
                        >
                          <Stack
                            flex="1 0 1"
                            justifyContent={center}
                            alignItems={center}
                            sx={{
                              "&:hover": {
                                backgroundColor: "#fff !important",
                                color: "black !important",
                              },
                            }}
                          >
                            <Box>
                              <Button
                                sx={{
                                  px: "19px",
                                  py: "7.73px",
                                  marginBottom: "19px !important",
                                  backgroundColor: "rgba(60, 55, 255, 0.15)",
                                  color: "#3C37FF",
                                  borderRadius: "19px",
                                  // display: { xs: "none", md: "block" },
                                }}
                              >
                                {value.lotteryName}
                              </Button>
                              <Divider
                                id="cardLine"
                                sx={{
                                  // display: { xs: "none", md: "block" },
                                  borderBottom:
                                    "0.727162px dashed rgba(255, 255, 255, 0.5)",
                                  mx: "-80px",
                                  "&:hover": {
                                    borderBottom:
                                      "0.727162px dashed black !important",
                                  },
                                }}
                              />
                            </Box>
                            {/* <Box>
                                <Typography component="h6" variant="h6">
                                  {value.firstDrawPrize}
                                </Typography>
                              </Box> */}
                            <Box sx={{ marginTop: "20px" }}>
                              {" "}
                              <Card
                                sx={{
                                  maxWidth: "144px",
                                  width: "144px",
                                  border:
                                    "1.2px solid rgba(255, 255, 255, 0.2)",
                                }}
                                style={content}
                              >
                                <div style={{ position: "relative" }}>
                                  <CardMedia
                                    sx={{
                                      height: "40.5px",
                                      backgroundColor: "#3C37FF",
                                      position: "relative",
                                      backgroundPosition: "initial",
                                    }}
                                    title="Next Draw"
                                    style={center}
                                  >
                                    Next Draw
                                  </CardMedia>
                                </div>
                                <CardContent
                                  sx={{
                                    padding: "7px",
                                    paddingBottom: "7px !important",
                                  }}
                                  style={center}
                                >
                                  <Typography
                                    sx={{ marginBottom: "0px" }}
                                    gutterBottom
                                  >
                                    <Countdown
                                      date={
                                        new Date(`${value?.lotteryDrawDate}`)
                                      }
                                    />
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Box>
                          </Stack>
                        </CardContent>
                      </Box>

                      {value?.soldStatus ? (
                        <Chip
                          label="Sold Out"
                          sx={{
                            position: "absolute",
                            transform: "rotate(-45deg)",
                            top: "2px",
                            left: "-31px",
                            backgroundColor: "red",
                            color: "#FFFFFF",
                            borderRadius: "4px",
                            padding: "4px 17px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            zIndex: "1000",
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </Card>
                  </Grid>
                ))}
            </Grid>
         
        </Box>
        {LotteryQuery?.data && LotteryQuery?.data?.length > 0 && (
          <Box display="flex" justifyContent="center" marginTop="40px">
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "white",
                  fontSize: "18px",
                },
                "& .MuiPaginationItem-page.Mui-selected": {
                  backgroundColor: "primary",
                  color: "white",
                  fontSize: "25px",
                },
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
